export const GET_PHOTOGRAPHER_OVERVIEW_SUCCESS = 'GET_PHOTOGRAPHER_OVERVIEW_SUCCESS';
